/**
 * Utilitaire contenant des fonctions statiques pour la gestion de l'écran
 * @category Utils
 * @hideconstructor
 */
var ScreenUtils = /*#__PURE__*/function () {
  function ScreenUtils() {}

  /**
  * Récupération de la hauteur disponible pour le contenu de l'application
  * @param {number} [offset=0] Marge supplémentaire à déduire
  * @returns {number} La hauteur disponible pour le contenu de l'application
  */
  ScreenUtils.getContentHeight = function getContentHeight(offset) {
    if (offset === void 0) {
      offset = 0;
    }

    var windowHeight = ScreenUtils.getScreenHeight(); // On déduit de la hauteur de l'écran un offset

    return windowHeight - offset;
  }
  /**
   * Récupération de la largeur disponible pour le contenu de l'application
   * @param {number} [offset=0] Marge supplémentaire à déduire
   * @returns {number} La largeur disponible pour le contenu de l'application
   */
  ;

  ScreenUtils.getContentWidth = function getContentWidth(offset) {
    if (offset === void 0) {
      offset = 0;
    }

    var windowWidth = ScreenUtils.getScreenWidth(); // On déduit de la hauteur de l'écran un offset

    return windowWidth - offset;
  }
  /**
   * Récupération de la hauteur totale de l'application
   * @returns {number} La hauteur totale de l'application
   */
  ;

  ScreenUtils.getScreenHeight = function getScreenHeight() {
    return window.innerHeight;
  }
  /**
   * Récupération de la largeur totale de l'application
   * @returns {number} La largeur totale de l'application
   */
  ;

  ScreenUtils.getScreenWidth = function getScreenWidth() {
    return window.innerWidth;
  };

  return ScreenUtils;
}(); // Exports


export var getContentHeight = ScreenUtils.getContentHeight;
export var getContentWidth = ScreenUtils.getContentWidth;
export var getScreenHeight = ScreenUtils.getScreenHeight;
export var getScreenWidth = ScreenUtils.getScreenWidth;